import { CSP_NONCE, Inject, Injectable } from '@angular/core';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MapService {

  private scriptLoaded: boolean = false;
  nonce: any;

  constructor(@Inject(CSP_NONCE) private cspNonce: string) { 
    this.nonce = cspNonce;
  }
  
  loadMapScript(callback: () => void) {
    const scriptSrc = "https://maps.googleapis.com/maps/api/js?key="+environment.googleAPIKey+"&libraries=places&callback=initMap&loading=async";
    // Verificar si el script ya existe
    const existingScript = document.querySelector(`script[src^="${scriptSrc}"]`);
    if (existingScript) {
      callback();
      return;
    } else {
      // Create the script tag, set the appropriate attributes
      let script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key="+environment.googleAPIKey+"&libraries=places&callback=initMap&loading=async";
      script.async = true;
      script.nonce = this.nonce;
      // Attach your callback function to the `window` object
      (<any>window).initMap = () => {
        // JS API is loaded and available
        callback();
      };
      /*script.onload = () => {
        console.log("Script loaded successfully!");
      };*/
      // Append the 'script' element to 'head'
      if (this.nonce) {
        script.setAttribute("nonce", this.nonce);
      }
      document.head.appendChild(script);
    }
  }

  /*loadMapScript(callback: () => void): void {
    const scriptSrc = "https://maps.googleapis.com/maps/api/js?key="+environment.googleAPIKey+"&libraries=places&callback=initMap";
    
    // Verificar si el script ya existe
    if (this.scriptLoaded) {
      callback(); // Llamar directamente al callback si el script ya está cargado
      return;
    }

    const existingScript = document.querySelector(`script[src^="${scriptSrc}"]`);
    if (existingScript) {
      this.scriptLoaded = true;
      callback(); // Llamar al callback si el script ya existe
    } else {
      this.loadScript(scriptSrc, callback);
    }
  }

  private loadScript(src: string, callback: () => void): void {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => {
      this.scriptLoaded = true;
      callback();
    };
    document.head.appendChild(script);
  }*/
}
